require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-energiehuis-deltawind.json") })
        }
      }, "path---projecten-energiehuis-deltawind");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-energiehuis-deltawind!./.cache/json/projecten-energiehuis-deltawind.json
// module id = 410
// module chunks = 231608221292675